



















































































































































import Vue from 'vue';
import * as printJs from 'print-js';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import ShipmentStatusHistory from '@/models/misc/ShipmentStatusHistory';

import shipmentsService from '@/services/ShipmentsService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      bol: null,
      snackbar: false,
      snackbarText: null,
      spinning: false,
      loadingScreenMessage: null,
      showLoadingScreen: false,
      currentTab: 'Status',
    };
  },
  mounted() {
    document.title = this.$route.params.shipmentId;
  },
  created() {
    this.loadDetails();
  },
  methods: {
    /* istanbul ignore next */
    print() {
      const blob = document.getElementsByTagName('iframe')[0].src;
      printJs.default({ printable: blob, type: 'pdf', showModal: true });
    },
    startLoading(message) {
      this.showLoadingScreen = true;
      this.loadingScreenMessage = message;
    },
    stopLoading() {
      this.showLoadingScreen = false;
      this.loadingScreenMessage = null;
    },
    noTrackingUrl() {
      this.snackbarText = 'No tracking URL available for this shipment';
      this.snackbar = true;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.shipmentId);
      this.snackbarText = `Shipment ${this.shipmentId} has been copied to the clipboard`;
      this.snackbar = true;
    },
    backToShipments() {
      window.location.href = '/customer/shipments';
    },
    loadDetails() {
      this.startLoading('Loading shipment history...');

      const shipmentId = this.$route.params.shipmentId;
      shipmentsService
        .getHistory(shipmentId)
        .then((x: ShipmentStatusHistory) => {
          this.stopLoading();

          this.bol = x;

          this.$refs.html2Pdf.generatePdf();
        });
    },
  },
  computed: {
    shipmentId() {
      return this.$route.params.shipmentId;
    },
    fileName() {
      return this.$route.params.shipmentId;
    },
    shipment() {
      return this.bol;
    },
  },
});
